import React from 'react'

export default function CreateNewCampaign() {
  return (
    <div>
      i am the create new campaign 
    </div>
  )
}
